module.exports = __webpack_public_path__ + "img/EvenMoreCriticals.0aae8e0d.png";